/**
 * Product Form Components
 *
 */
let trySku = null;

class ProductForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.productNameMain = this.form.getAttribute('data-productTitle');
    
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    this.productDiv = this.querySelectorAll('[data-productDiv]');
    this.productDiv.forEach(productDiv => productDiv.addEventListener('click', this.getProductFromRadio.bind(this)));

    this.allSoldoutInput = this.querySelectorAll('[data-all-soldout]');
    this.allSoldoutInput.forEach(allSoldoutInput =>
      allSoldoutInput.closest('.product-shade-list').classList.add('bundle-disable')
    );

    this.collection_products_json = this.form.querySelector('[data-collectionProductsJSON]');

    let preorderProp, preorderPropDate;
    if (document.querySelector('input#preorder_prop')) {
      preorderProp = document.querySelector('input#preorder_prop').value;
      preorderPropDate = document.querySelector('input#preorder_prop_date').value;
    }
    this.variantInputs = this.querySelectorAll('[data-main-product-variants] input');
    this.variantInputs.forEach(variantInput => variantInput.addEventListener('click', this.updateInfo.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const bundleItems = [];
    var currentTarget = evt.currentTarget;
    const qtyInput = this.querySelector('[data-qty-input]') || null;
    const submitButton = this.querySelector('[type="submit"]');
    var maxQty = null;

    if (qtyInput.hasAttribute('max')) {
      maxQty = Number(qtyInput.getAttribute('max'));
    }

    let quantity = 1;
    if (qtyInput != null && qtyInput) {
      quantity = qtyInput.value;
    }
    let productId = this.form.querySelector('input[name="id"]').value;
    if (this.form.querySelector('[data-productDiv] input[type="radio"]:checked')) {
      productId = this.form.querySelector('[data-productDiv] input[type="radio"]:checked').dataset.productvarid;
    }



    let preorderProp = '', preorderPropDate = '';
    if (document.querySelector('input#preorder_prop')) {
      preorderProp = document.querySelector('input#preorder_prop').value;
      preorderPropDate = document.querySelector('input#preorder_prop_date').value;
    }

    if (submitButton.hasAttribute("data-bundle-add")) {
      let bundleItemEle = this.querySelectorAll('[data-bundle-item]');

      if (bundleItemEle != null) {
        bundleItemEle.forEach((bundle) => {
          if (bundle.checked) {
            bundleItems.push(bundle.getAttribute('data-productVarId'));
          }
        });
      }

      addItems.push({
        id: parseInt(productId),
        quantity: parseInt(quantity),
        properties: {
          bundle_main_product: parseInt(productId),
          bundle_products: bundleItems
        }
      });

      if (bundleItemEle != null) {
        bundleItemEle.forEach((bundle) => {
          if (bundle.checked) {
            let bundleJSON = {
              id: bundle.getAttribute('data-productVarId'),
              quantity: parseInt(quantity),
              properties: {
                main_bundle: parseInt(bundle.getAttribute('data-mainProductid')),
                product_type: 'sub_product',
                bundle_products: bundleItems
              }
            }
            addItems.push(bundleJSON);
          }
        });
      }

      var body = {
        items: addItems
      };
    } else {
      var body = {
        id: parseInt(productId),
        quantity: parseInt(quantity),
        properties: {
          pre_order: preorderProp,
          pre_order_date: preorderPropDate
        }
      }
    }


    var cartItems = window.globalVariables.cart.items;
    if (cartItems.length > 0) {
      for (const [i, item] of cartItems.entries()) {
        var compareQty = Number(quantity) + Number(item.quantity);
        if (productId == item.variant_id && compareQty > maxQty && maxQty != null) {
          qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]').classList.remove('d-none');
          currentTarget.querySelector('[data-main-product-btn]').classList.add('disable-element');
          setTimeout(() => {
            Utility.fadeEffectOut(qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]'));
            currentTarget.querySelector('[data-main-product-btn]').classList.remove('disable-element');
          }, 3000);
          return false;
        }
      }
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const result = fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    }).then(response => {
      //if (!response.ok) { Rollbar.critical(`Product name: ${this.productNameMain} Filename: component-product-form.js, Error found while Add to cart.`); }
      if (document.querySelector('#PopupModal-quickshop')) {
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'));
      }
      this.cartElement.getCartData('open_drawer');
      if (qtyInput) qtyInput.value = 1;
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }).catch(function(err) {
      Rollbar.critical(`Product name: ${this.productNameMain} Filename: component-product-form.js, Error found while Add to cart.: ${err}`);
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      var maxQty = null;

      if ($qtyInput.hasAttribute('max')) {
        maxQty = Number($qtyInput.getAttribute('max'));
      }
      var productId = Number(this.form.querySelector('input[name="id"]').value);
      if (this.form.querySelector('[data-productDiv] input[type="radio"]:checked')) {
        productId = Number(this.form.querySelector('[data-productDiv] input[type="radio"]:checked').dataset.productvarid);
      }

      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;

      if (action == 'decrease' && currentQty <= 1) {
        return false;
      } else if (action == 'decrease') {
        finalQty = currentQty - 1;
      } else {
        var comparedMax = false;
        var cartItems = window.globalVariables.cart.items;
        if (cartItems.length > 0) {
          for (const [i, item] of cartItems.entries()) {
            var compareQty = Number(currentQty) + Number(item.quantity);

            if (productId == item.variant_id && compareQty >= maxQty && maxQty != null) {
              comparedMax = true;
              $qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]').classList.remove('d-none');
              $qtyInput.closest('.wrapper-parent').querySelector('[data-for="increase"]').classList.add('disable-element');
              $qtyInput.closest('.wrapper-parent').querySelector('[data-for="decrease"]').classList.add('disable-element');
              setTimeout(() => {
                Utility.fadeEffectOut($qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]'));
                $qtyInput.closest('.wrapper-parent').querySelector('[data-for="increase"]').classList.remove('disable-element');
                $qtyInput.closest('.wrapper-parent').querySelector('[data-for="decrease"]').classList.remove('disable-element');
              }, 3000);
              return false;
            }
          }
        }
        if (comparedMax == false) {
          if (currentQty >= maxQty && maxQty != null) {
            $qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]').classList.remove('d-none');
            $qtyInput.closest('.wrapper-parent').querySelector('[data-for="increase"]').classList.add('disable-element');
            $qtyInput.closest('.wrapper-parent').querySelector('[data-for="decrease"]').classList.add('disable-element');
            setTimeout(() => {
              Utility.fadeEffectOut($qtyInput.closest('.wrapper-parent').querySelector('[data-qty-error]'));
              $qtyInput.closest('.wrapper-parent').querySelector('[data-for="increase"]').classList.remove('disable-element');
              $qtyInput.closest('.wrapper-parent').querySelector('[data-for="decrease"]').classList.remove('disable-element');
            }, 3000);
            return false;
          } else {
            finalQty = currentQty + 1;
          }
        }
      }
      $qtyInput.value = finalQty;
    } catch (error) {
      Rollbar.error(`Product name: ${this.productNameMain} File: Compoment-product-form.js, Error found while manage quantity.`);
    }
  }

  getProductFromRadio(event) {
    event.preventDefault();
    let $this = this;
    let currentTarget = event.currentTarget;
    let collectionProducts = this._getCollectionProductsData();
    if (currentTarget.closest('.wrapper-parent') != undefined) {
      var $qtyInput = currentTarget.closest('.wrapper-parent').querySelector('[data-qty-input]');
      $qtyInput.value = 1;
    }

    let selectedOption = currentTarget.querySelector('.variant-input input[type="radio"]');
    selectedOption.checked = true;
    let productAvail = selectedOption.dataset.productavailable;
    let format = selectedOption.dataset.format;

    if (format == "product-page" && (dmbTryOnOptions != null && dmbTryOnOptions.enable_tryon == true)) {
      if (selectedOption != '') {
        variantChange(selectedOption);
      } else {
        Rollbar.error(`Filename: Component-product-form.js, selected option have no value`)
      }
    }

    let productId = selectedOption.dataset.proid;
    let productTitle = selectedOption.dataset.protitle;
    let shadeDesc = selectedOption.dataset.shadedesc;
    let featureImg = selectedOption.dataset.productfeatureimg;

    var productMaxLimit = null;
    if (selectedOption.hasAttribute('data-productMax')) {
      productMaxLimit = selectedOption.dataset.productmax;
    }


    let productURL = selectedOption.dataset.url || null;
    let productVarId = selectedOption.dataset.productvarid || null;
    if (productURL != null && productVarId != null) {
      this.updateURLandID(productURL, productVarId, format);
    }

    let productPrice = selectedOption.dataset.productprice;

    if (format != "bundle") {
      let priceElement = document.querySelector('[data-currentPrice]');
      if (priceElement.closest('.data-bundle-add')) priceElement.innerHTML = productPrice;
    }


    if (selectedOption.hasAttribute('main-product-swatch')) {
      let bundleItemEle = this.querySelectorAll('[data-bundle-item]');
      if (bundleItemEle != null) {
        bundleItemEle.forEach((bundle) => {
          bundle.setAttribute('data-mainproductid', productVarId);
        });
      }
    }

    let openModel = '';
    let thumbParent = '';
    let sliderParent = '';
    let slidesHTML = '';
    let thumbnailsHTML = '';
    let setProductTitle = '';
    let setShadeDesc = '';
    let setMaxQty = '';

    if (format == "quickshop") {
      try {
        openModel = document.querySelector('#PopupModal-quickshop .open');
        thumbParent = document.querySelector('#PopupModal-quickshop [data-thumbSlider]');
        sliderParent = document.querySelector('#PopupModal-quickshop [data-main-slider]');
        setProductTitle = document.querySelector('#PopupModal-quickshop [data-setProductTitle]');
        setMaxQty = document.querySelector('#PopupModal-quickshop [data-qty-input]');
        if (setProductTitle) setProductTitle.innerHTML = productTitle;
        setShadeDesc = document.querySelector('#PopupModal-quickshop [data-setShadeDesc]');
        if (setShadeDesc) setShadeDesc.innerHTML = shadeDesc;
        if (setMaxQty && productMaxLimit != null) {
          setMaxQty.setAttribute('max', productMaxLimit);
        } else {
          setMaxQty.removeAttribute('max');
        }

        let addToCartBtn = openModel.querySelector('[data-btnAddToCart]');
        if (productAvail == 'false') {
          addToCartBtn.setAttribute('disabled', true);
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
          }
        } else {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${productPrice}</span>`;
          }
        };

        collectionProducts.forEach(function (product, v) {
          if (productId == product.id) {
            let productMedia = product.media;
            productMedia.forEach(function (i, v) {
              if (i.media_type == "video" || i.media_type == "external_video") {
                thumbnailsHTML += `<div class="swiper-slide" data-mediaID="${i.id}" role="treeitem">
                                                    <div class=" media--video">
                                                        <img class="img-fluid"
                                                        src="${i.preview_image.src}"
                                                        alt="${i.alt}" sizes="250px" loading="lazy" width="${i.width}" height="${i.height}" />
                                                        <div class="thumb-video-overlay">
                                                        <svg width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
                                                            <g id="Group_692" data-name="Group 692" transform="translate(0.25 0.15)">
                                                            <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                                                <circle id="Ellipse_6" data-name="Ellipse 6" cx="10" cy="10" r="10" fill="none" stroke="#fff" stroke-width="1.5"/>
                                                                <path id="Path_1258" data-name="Path 1258" d="M14.061,9.943,8.5,6.607v6.673Z" transform="translate(-0.343 0.152)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                            </g>
                                                            </g>
                                                        </svg>
                                                        </div>
                                                    </div>
                                                </div>`;
                slidesHTML += `<div class="swiper-slide d-flex align-items-center" data-mediaID="${i.id}" role="treeitem">
                                            <div class="product--media">
                                                <div class="custom-video-container">
                                                <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                                    <div class="cta-btn">
                                                    <button class="play__button btn p-0" data-trigger-video aria-label="Play Video">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="43.5" height="43.5" viewBox="0 0 43.5 43.5">
                                                            <g id="Group_727" data-name="Group 727" transform="translate(0.25 0.15)">
                                                            <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                                                <path id="Path_1264" data-name="Path 1264" d="M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z" fill="#fff" stroke="#fff" stroke-width="1.5"></path>
                                                                <path id="Path_1258" data-name="Path 1258" d="M20.18,13.615,8.5,6.607V20.623Z" transform="translate(8.634 7.589)" fill="#4c4c4c" stroke="#4c4c4c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                                            </g>
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <button class="pause__button btn p-0" data-pause-video aria-label="Pause Video">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                                        <g clip-path="url(#clip0_667_198)">
                                                        <path d="M21.75 0.75C25.9034 0.75 29.9635 1.98163 33.417 4.28914C36.8704 6.59665 39.562 9.8764 41.1515 13.7136C42.7409 17.5509 43.1568 21.7733 42.3465 25.8469C41.5362 29.9205 39.5361 33.6623 36.5992 36.5992C33.6623 39.5361 29.9205 41.5362 25.8469 42.3465C21.7733 43.1568 17.5509 42.7409 13.7136 41.1515C9.8764 39.562 6.59665 36.8704 4.28914 33.417C1.98163 29.9635 0.75 25.9034 0.75 21.75C0.75 16.1805 2.96249 10.839 6.90076 6.90076C10.839 2.96249 16.1805 0.75 21.75 0.75V0.75Z" fill="white" stroke="white" stroke-width="1.5"/>
                                                        <path d="M19.8733 27.0579V16.2004C19.8733 15.3404 19.515 15 18.6012 15H16.2721C15.3583 15 15 15.3404 15 16.2004V27.0579C15 27.9179 15.3583 28.2583 16.2721 28.2583H18.5833C19.515 28.2583 19.8733 27.9179 19.8733 27.0579Z" fill="#4C4C4C"/>
                                                        <path d="M29.3333 27.0579V16.2004C29.3333 15.3404 28.975 15 28.0612 15H25.75C24.8362 15 24.4779 15.3404 24.4779 16.2004V27.0579C24.4779 27.9179 24.8362 28.2583 25.75 28.2583H28.0612C28.975 28.2583 29.3333 27.9179 29.3333 27.0579Z" fill="#4C4C4C"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_667_198">
                                                        <rect width="43.5" height="43.5" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                        </svg>
                                                    </button>
                                                    </div>
                                                    <div class="content-section">
                                                    <div class="poster-image">
                                                        <img class="img-fluid"
                                                        src="${i.preview_image.src}"
                                                        alt="${i.alt}"/>
                                                    </div>
                                                    </div>
                                                    <div class="video-section" tabindex="0"></div>
                                                </custom-video>
                                                </div>
                                            </div>
                                        </div>`;
              } else {
                thumbnailsHTML += `<div class="swiper-slide" data-mediaID="${i.id}" role="treeitem">
                                                <div class="product-thumb--image">
                                                    <img class="img-fluid"
                                                    src="${i.preview_image.src}"
                                                    alt="${i.alt}" sizes="250px" loading="lazy" width="${i.width}" height="${i.height}" />
                                                </div>
                                            </div>`;
                slidesHTML += `<div class="swiper-slide d-flex align-items-center" data-mediaID="${i.id}" role="treeitem">
                                            <div class="product--media">
                                                <img src="${i.preview_image.src}"
                                                alt="${i.alt}" loading="lazy" width="${i.width}" height="${i.height}" />
                                            </div>
                                        </div>`;
              }
            });
            let finalnavHTML = `<slider-element  class="swiper-container px-2 position-relative thumb-vertical-grid d-none d-md-block" data-thumbSlider data-direction="vertical">
                                            <div class="swiper swiper-slider product-thumbnails" data-slider='{
                                                "direction": "vertical",
                                                "loop": false,
                                                "slidesPerView": "5",
                                                "spaceBetween": 10,
                                                "grabCursor": true,
                                                "slideToClickedSlide": true,
                                                "navigation": {
                                                    "nextEl": ".quick-button-next",
                                                    "prevEl": ".quick-button-prev"
                                                }
                                            }' role="tree">
                                            <div class="swiper-wrapper">${thumbnailsHTML}</div>
                                            </div>
                                            <div class="swiper-button-next quick-button-next icon-sm-arrow-down"></div>
                                            <div class="swiper-button-prev quick-button-prev icon-sm-arrow-up"></div>
                                        </slider-element >`;
            thumbParent.innerHTML = finalnavHTML;

            let finalHTML = `<slider-element class="swiper-container" data-main-slider>
                                        <div class="swiper swiper-slider product-carousel quickshop-slider" data-nav="product-thumbnails" data-slider='{
                                            "loop": false,
                                            "slidesPerView": "1",
                                            "spaceBetween": 15,
                                            "grabCursor": true
                                        }' role="tree">
                                        <div class="swiper-wrapper">${slidesHTML}</div>
                                        </div>
                                    </slider-element>`;
            sliderParent.innerHTML = finalHTML;
          }
        });

        let variantsHTML = '';
        collectionProducts.forEach(function (product, v) {
          if (productId == product.id) {
            let className = '';
            if (product.options.length == 1 && product.options[0] == 'Title') {
              className = 'd-none';
            }

            variantsHTML += ` <variant-radios class="no-js-hidden ${className}" data-section="" data-url="/products/${product.handle}" data-type="variant-radios">`;

            product.options.forEach(function (v, i) {

              var currentVariant = product.variants.find(function (element) {
                return element.available;
              });
              if (currentVariant == undefined) {
                currentVariant = product.variants[0];
              }

              variantsHTML += ` <fieldset class="js product-form__input mb-0" data-optionindex="${i + 1}">
                        <legend class="d-block fw-semibold mb-2 text-capitalize">${v}: <span class="ms-2 fw-normal selected-option" data-option-selected-val>${currentVariant.title}</span></legend>
                        <ul class="d-flex flex-wrap list-unstyled my-0 py-0 shade-ul">`;
              let valueArray = [];

              let CheckedAttributtes = '';
              let flag = true;

              product.variants.forEach(function (variant, j) {
                let mediaId = '';
                if (variant.available && flag) {
                  CheckedAttributtes = 'checked';
                  flag = false;
                }
                else {
                  CheckedAttributtes = '';
                }
                if (variant.featured_media != null) {
                  mediaId = variant.featured_media.id;
                }
                let value = variant.options[i];
                if (jQuery.inArray(value, valueArray) == -1) {
                  variantsHTML += `<li class="me-2 mb-0">
                                    <div class="swatch shade-swatch gift-card">
                                        <input type="radio" class="form-control" data-media-id="${mediaId}" data-url="/products/${product.handle}" id="swatch-${product.id}-${variant.id}" data-vari-price="${Shopify.formatMoney(variant.price, window.globalVariables.money_format)}" data-vari-id="${variant.id}" data-vari-available="${variant.available}" data-format="${format}" swatch-${product.id}-${variant.id}"
                                            name="${v}" value="${value}"
                                            data-handle="${value.toLowerCase()}" ${CheckedAttributtes}>
                                        <label class="form-label swatch-label {{ value }}" for="swatch-${product.id}-${variant.id}" title="${value}"> ${value} </label>
                                    </div>
                                    </li>`;
                  valueArray.push(value);
                }
              });
              variantsHTML += `</ul>`;
              variantsHTML += `</fieldset>`;
            });
            variantsHTML += `</variant-radios>`;
            document.querySelector('#PopupModal-quickshop [data-main-product-variants]').innerHTML = variantsHTML;
            $this.variantInputs = $this.querySelectorAll('[data-main-product-variants] input');
            $this.variantInputs.forEach(variantInput => variantInput.addEventListener('click', $this.updateInfo.bind(this)));
          }
        });
      } catch (error) {
        Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while quick view.`)
      }
    } else if (format == "bundle") {
      try {
        setProductTitle = currentTarget.closest('[data-product-shade-list]').querySelector('[data-bundleTitle]');
        if (setProductTitle) setProductTitle.innerHTML = productTitle;
        setShadeDesc = currentTarget.closest('[data-product-shade-list]').querySelector('[data-setShadeDescBundle]');
        if (setShadeDesc) setShadeDesc.innerHTML = shadeDesc;
        let featureProImg = currentTarget.closest('[data-product-shade-list]').querySelector('[data-pro-feature-img]');
        if (featureImg) featureProImg.src = featureImg;
      } catch (error) {
        Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while Bundle popup Custom Shades get.`);
      }
    } else {
      try {
        thumbParent = document.querySelector('[data-thumbSlider]');
        sliderParent = document.querySelector('[data-main-slider]');
        setProductTitle = document.querySelector('[data-setProductTitle]');
        if (setProductTitle) setProductTitle.innerHTML = productTitle;
        setShadeDesc = document.querySelector('[data-setShadeDesc]');
        if (setShadeDesc) setShadeDesc.innerHTML = shadeDesc;
        setMaxQty = document.querySelector('[data-qty-input]');
        if (setMaxQty && productMaxLimit != null) {
          setMaxQty.setAttribute('max', productMaxLimit);
        } else {
          setMaxQty.removeAttribute('max');
        }
        let addToCartBtn = document.querySelector('[data-btnAddToCart]');
        if (productAvail == 'false') {
          addToCartBtn.setAttribute('disabled', true);
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
          }
        } else {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${productPrice}</span>`;
          }
        };

        collectionProducts.forEach(function (product, v) {
          if (productId == product.id) {
            let productMedia = product.media;
            productMedia.forEach(function (i, v) {
              if (i.media_type == "video" || i.media_type == "external_video") {
                thumbnailsHTML += `<div class="swiper-slide" data-mediaID="${i.id}" role="treeitem">
                                            <div class="product-thumb--image media--video">
                                            <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}" sizes="250px" loading="lazy" width="${i.width}" height="${i.height}" />
                                            <div class="thumb-video-overlay">
                                                <svg width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
                                                <g id="Group_692" data-name="Group 692" transform="translate(0.25 0.15)">
                                                    <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                                    <circle id="Ellipse_6" data-name="Ellipse 6" cx="10" cy="10" r="10" fill="none" stroke="#fff" stroke-width="1.5"/>
                                                    <path id="Path_1258" data-name="Path 1258" d="M14.061,9.943,8.5,6.607v6.673Z" transform="translate(-0.343 0.152)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                    </g>
                                                </g>
                                                </svg>
                                            </div>
                                            </div>
                                        </div>`;
                slidesHTML += `<div class="swiper-slide d-flex align-items-center gh" data-mediaID="${i.id}" role="treeitem">
                                        <div class="product--media">
                                        <div class="custom-video-container">
                                            <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                            <div class="cta-btn">
                                                <button class="play__button btn p-0" data-trigger-video aria-label="Play Video">
                                                	<svg xmlns="http://www.w3.org/2000/svg" width="43.5" height="43.5" viewBox="0 0 43.5 43.5">
                                                            <g id="Group_727" data-name="Group 727" transform="translate(0.25 0.15)">
                                                            <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                                                <path id="Path_1264" data-name="Path 1264" d="M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z" fill="#fff" stroke="#fff" stroke-width="1.5"></path>
                                                                <path id="Path_1258" data-name="Path 1258" d="M20.18,13.615,8.5,6.607V20.623Z" transform="translate(8.634 7.589)" fill="#4c4c4c" stroke="#4c4c4c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                                            </g>
                                                            </g>
                                                        </svg>
                                                </button>
                                                <button class="pause__button btn p-0" data-pause-video aria-label="Pause Video">
                                               		<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                                    <g clip-path="url(#clip0_667_198)">
                                                    <path d="M21.75 0.75C25.9034 0.75 29.9635 1.98163 33.417 4.28914C36.8704 6.59665 39.562 9.8764 41.1515 13.7136C42.7409 17.5509 43.1568 21.7733 42.3465 25.8469C41.5362 29.9205 39.5361 33.6623 36.5992 36.5992C33.6623 39.5361 29.9205 41.5362 25.8469 42.3465C21.7733 43.1568 17.5509 42.7409 13.7136 41.1515C9.8764 39.562 6.59665 36.8704 4.28914 33.417C1.98163 29.9635 0.75 25.9034 0.75 21.75C0.75 16.1805 2.96249 10.839 6.90076 6.90076C10.839 2.96249 16.1805 0.75 21.75 0.75V0.75Z" fill="white" stroke="white" stroke-width="1.5"/>
                                                    <path d="M19.8733 27.0579V16.2004C19.8733 15.3404 19.515 15 18.6012 15H16.2721C15.3583 15 15 15.3404 15 16.2004V27.0579C15 27.9179 15.3583 28.2583 16.2721 28.2583H18.5833C19.515 28.2583 19.8733 27.9179 19.8733 27.0579Z" fill="#4C4C4C"/>
                                                    <path d="M29.3333 27.0579V16.2004C29.3333 15.3404 28.975 15 28.0612 15H25.75C24.8362 15 24.4779 15.3404 24.4779 16.2004V27.0579C24.4779 27.9179 24.8362 28.2583 25.75 28.2583H28.0612C28.975 28.2583 29.3333 27.9179 29.3333 27.0579Z" fill="#4C4C4C"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_667_198">
                                                    <rect width="43.5" height="43.5" fill="white"/>
                                                    </clipPath>
                                                    </defs>
                                                    </svg>
                                                </button>
                                            </div>
                                            <div class="content-section">
                                                <div class="poster-image">
                                                <img class="img-fluid"
                                                    src="${i.preview_image.src}"
                                                    alt="${i.alt}"/>
                                                </div>
                                            </div>
                                            <div class="video-section" tabindex="0"></div>
                                            </custom-video>
                                        </div>
                                      </div>
                                    </div>`;
              } else {
                thumbnailsHTML += `<div class="swiper-slide" data-mediaID="${i.id}" role="treeitem">
                                            <div class="product-thumb--image">
                                            <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}" sizes="250px" loading="lazy" width="${i.width}" height="${i.height}" />
                                            </div>
                                        </div>`;
                slidesHTML += `<div class="swiper-slide d-flex align-items-center" data-mediaID="${i.id}" role="treeitem">
                                        <div class="product--media">
                                        <img src="${i.preview_image.src}"
                                            alt="${i.alt}" loading="lazy" width="${i.width}" height="${i.height}" />
                                        </div>
                                    </div>`;
              }
            });
            let finalnavHTML = ` <div class="swiper swiper-slider product-thumbnails" data-slider='{
                                            "direction": "vertical",
                                            "loop": false,
                                            "slidesPerView": "5",
                                            "spaceBetween": 10,
                                            "grabCursor": true,
                                            "slideToClickedSlide": true,
                                            "navigation": {
                                                "nextEl": ".thumb-button-next",
                                                "prevEl": ".thumb-button-prev"
                                            },
                                            "breakpoints": {
                                                "768": {
                                                "slidesPerView": "auto",
                                                "spaceBetween": 12
                                                }
                                            }
                                            }' role="tree">
                                        <div class="swiper-wrapper">${thumbnailsHTML}</div>
                                        <div class="swiper-button-next thumb-button-next icon-sm-arrow-down" role="treeitem"></div>
                                        <div class="swiper-button-prev thumb-button-prev icon-sm-arrow-up "role="treeitem"></div>
                                    </div>`;
            thumbParent.innerHTML = finalnavHTML;

            let finalHTML = `<slider-element class="swiper-container">
                                    <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails" data-slider='{
                                        "loop": false,
                                        "slidesPerView": "1",
                                        "spaceBetween": 15,
                                        "grabCursor": true,
                                        "pagination": {
                                            "el": ".swiper-pagination"
                                        }
                                    }' role="tree">
                                    <div class="swiper-wrapper">${slidesHTML}</div>
                                    <div class="swiper-pagination position-relative mt-2 d-md-none w-100"></div>
                                    </div>
                                </slider-element>`;
            sliderParent.innerHTML = finalHTML;
          }
        });

        let variantsHTML = '';
        collectionProducts.forEach(function (product, v) {
          if (productId == product.id) {
            let className = '';
            if (product.options.length == 1 && product.options[0] == 'Title') {
              className = 'd-none';
            }
            variantsHTML += ` <variant-radios class="no-js-hidden ${className}" data-section="" data-url="/products/${product.handle}" data-type="variant-radios">`;
            product.options.forEach(function (v, i) {
              var currentVariant = product.variants.find(function (element) {
                return element.available;
              });
              if (currentVariant == undefined) {
                currentVariant = product.variants[0];
              }
              variantsHTML += ` <fieldset class="js product-form__input" data-optionindex="${i + 1}">
                        <legend class="d-block fw-semibold mb-2 text-capitalize">${v}: <span class="ms-2 fw-normal selected-option" data-option-selected-val>${currentVariant.title}</span></legend>
                        <ul class="d-flex flex-wrap list-unstyled my-0 py-0 shade-ul">`;
              let valueArray = [];

              let CheckedAttributtes = '';
              let flag = true;

              product.variants.forEach(function (variant, j) {
                let mediaId = '';
                if (variant.available && flag) {
                  CheckedAttributtes = 'checked';
                  flag = false;
                }
                else {
                  CheckedAttributtes = '';
                }
                if (variant.featured_media != null) {
                  mediaId = variant.featured_media.id;
                }
                let value = variant.options[i];
                if (jQuery.inArray(value, valueArray) == -1) {
                  variantsHTML += `<li class="me-2 mb-0">
                                    <div class="swatch shade-swatch gift-card">
                                        <input type="radio" class="form-control" data-media-id="${mediaId}" data-url="/products/${product.handle}" id="swatch-${product.id}-${variant.id}" data-vari-price="${Shopify.formatMoney(variant.price, window.globalVariables.money_format)}" data-vari-id="${variant.id}" data-vari-available="${variant.available}" data-format="${format}" swatch-${product.id}-${variant.id}"
                                            name="${v}" value="${value}"
                                            data-handle="${value.toLowerCase()}" ${CheckedAttributtes}>
                                        <label class="form-label swatch-label {{ value }}" for="swatch-${product.id}-${variant.id}" title="${value}"> ${value} </label>
                                    </div>
                                    </li>`;
                  valueArray.push(value);
                }
              });
              variantsHTML += `</ul>`;
              variantsHTML += `</fieldset>`;
            });
            variantsHTML += `</variant-radios>`;
            document.querySelector('[data-main-product-variants]').innerHTML = variantsHTML;
            $this.variantInputs = $this.querySelectorAll('[data-main-product-variants] input');
            $this.variantInputs.forEach(variantInput => variantInput.addEventListener('click', $this.updateInfo.bind(this)));
          }
        });
      } catch (error) {
        Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while product page shades display.`)
      }

    }
  }

  updateInfo(event) {
    try{
      let currentTarget = event.currentTarget;
      let variantPrice = currentTarget.getAttribute('data-vari-price');
      let variantId = currentTarget.getAttribute('data-vari-id');
      let variantAvailable = currentTarget.getAttribute('data-vari-available');
      let format = currentTarget.getAttribute('data-format');
      let value = currentTarget.value;
      let element = document.querySelector('[data-productdiv] input:checked');

      console.log('element',element)

      let url = currentTarget.getAttribute('data-url') || null;
      let mediaId = currentTarget.getAttribute('data-media-id') || null;
      let variantTitle = currentTarget.getAttribute('data-variant-title');
      if(element != null){
        element.setAttribute('data-productprice', variantPrice);
        element.setAttribute('data-productvarid', variantId);
        element.setAttribute('data-productavailable', variantAvailable);
      }

      if (format == 'product-page') window.history.replaceState({}, '', `${url}?variant=${variantId}`);

      if (format == 'quickshop') {

        // window.globalVariables.product.currentVariant = this.currentVariant;
        // document.dispatchEvent(new Event('variant:click'));
        // document.dispatchEvent(new Event('variant:changed'));

        let openModel = document.querySelector('#PopupModal-quickshop .open');
        let addToCartBtn = openModel.querySelector('[data-btnAddToCart]');
        if (openModel.querySelector('[data-option-selected-val]')) {
          let optionElment = openModel.querySelector('[data-option-selected-val]');
          optionElment.textContent = value;
        }
        if (variantAvailable == 'false') {
          addToCartBtn.setAttribute('disabled', true);
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
          }
        } else {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${variantPrice}</span>`;
          }

        };
      }
      else {
        let optionElment = document.querySelector('[data-option-selected-val]');
        let addToCartBtn = document.querySelector('[data-btnAddToCart]');
        if (optionElment != undefined || optionElment != null) {
          optionElment.textContent = value;
        }
        if (variantAvailable == 'false') {
          addToCartBtn.setAttribute('disabled', true);
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
          }
        } else {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${variantPrice}</span>`;
          }
        };
      }
      if (mediaId != null) {
        let currentSlider = document.querySelector('.product-carousel') 
        if(format == 'quickshop'){
          currentSlider = document.querySelector('.quickshop-image .product-carousel') 
        }
        let sliderOptions = currentSlider.getAttribute('data-slider');


        let slideEle = currentSlider.querySelector(`[data-mediaid="${mediaId}"]`);
        if(slideEle){
          let slideIndex = Array.from(slideEle.parentNode.children).indexOf(slideEle);
          if (slideIndex == null || slideIndex == undefined) { return; }

          sliderOptions = JSON.parse(sliderOptions);
          let swiper = new Swiper(currentSlider, sliderOptions);
          swiper.slideTo(slideIndex);
        }


        setTimeout(() => {
          let thumbSlider = document.querySelector('.product-thumbnails');
          if(format == 'quickshop'){
            thumbSlider = document.querySelector('.quickshop-image .product-thumbnails') 
          }
          //console.log('thumbSlider',thumbSlider)
          thumbSlider.querySelectorAll(`[data-mediaid]`).forEach(slide => {
            slide.classList.remove('swiper-slide-thumb-active');
            slide.classList.remove('swiper-slide-active');
          });
          if(thumbSlider.querySelector(`[data-mediaid="${mediaId}"]`)){
            thumbSlider.querySelector(`[data-mediaid="${mediaId}"]`).classList.add('swiper-slide-thumb-active');
            thumbSlider.querySelector(`[data-mediaid="${mediaId}"]`).classList.add('swiper-slide-active');
          }
        }, 200);
      }
    }catch(err){
       console.log(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while update information when shade changes: ${err}`);
      
    }
  }

  updateURLandID(url, varid, format) {

    // update query string with latest variant ID
    if (format == 'product-page') window.history.replaceState({}, '', `${url}?variant=${varid}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = varid;
  }

  _getCollectionProductsData() {
    if (this.collection_products_json.textContent || this.collection_products_json.textContent != '') {
      this.collectionProductsData = JSON.parse(this.collection_products_json.textContent);
      return this.collectionProductsData;
    } else {
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured when collection tag not found product.`)
    }
  }

}
customElements.define('product-form', ProductForm);

class ProductFormGetLook extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('ajax-cart');

    this.productDiv = this.querySelectorAll('[data-productDiv]');
    this.productDiv.forEach(productDiv => productDiv.addEventListener('click', this.getProductFromRadio.bind(this)));

    this.collection_products_json = this.form.querySelector('[data-collectionProductsJSON]');

  }

}
customElements.define('product-form-getlook', ProductFormGetLook);

class VariantSelects extends HTMLElement {

  constructor() {
    super();

    this.form = this.closest('form') || this.closest('.productForm');
    this.productNameMain = this.form.getAttribute('data-productTitle');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    this.collection_products_json = this.form.querySelector('[data-collectionProductsJSON]');

    this.addEventListener('change', this.onVariantChangeCustom.bind(this));

    if (this.formType == 'product-page') {
      window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new Event('variant:click'));
      document.dispatchEvent(new Event('variant:changed'));

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 700)
    }

  }

  onVariantChangeCustom(event) {
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let collectionProducts = this._getCollectionProductsData();
      let selectedOption = currentTarget.querySelector('select');
      if (selectedOption != null) {
        let getOptionEle = selectedOption.options[selectedOption.selectedIndex];

        let productTitle = getOptionEle.dataset.protitle;
        let productVarId = getOptionEle.dataset.productvarid || null;
        let productPrice = getOptionEle.dataset.productprice;
        let productImage = getOptionEle.dataset.productimg;
        let productId = getOptionEle.dataset.proid;

        var setProductImg = currentTarget.closest('.get-look-block').querySelector('[data-getlook-img]');
        if (setProductImg) setProductImg.setAttribute('src', productImage);
        var setVarId = currentTarget.closest('.get-look-block').querySelector('[data-getlook-varid]');
        if (setVarId) setVarId.setAttribute('data-getlook-varid', productVarId);
        var setProductTitle = currentTarget.closest('.get-look-block').querySelector('[data-getlook-title]');
        if (setProductTitle) setProductTitle.innerHTML = productTitle;
        var setProductPrice = currentTarget.closest('.get-look-block').querySelector('[data-getlook-price]');
        if (setProductPrice) setProductPrice.innerHTML = productPrice;

        let productAvailable = getOptionEle.dataset.productavailable;
        let addToCartBtn = currentTarget.closest('.get-look-block').querySelector('[data-getlook-atc]');
        if (productAvailable == 'false') {
          addToCartBtn.setAttribute('disabled', true);
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
          }
        } else {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartBtn.querySelector('.add-text .text-for-print')) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `+ADD`;
          }
        };

        var availableCount = 0;
        var totalAllPrice = 0;
        document.querySelector('#getLookSection').querySelectorAll('select').forEach(select => {

          if (select.options[select.selectedIndex].getAttribute('data-productavailable') == 'false') {
            availableCount = availableCount + 1;
          } else {
            totalAllPrice = totalAllPrice + Number(select.options[select.selectedIndex].getAttribute('data-productOrgPrice'));
          }
          if (availableCount == Number(document.querySelector('#getLookSection').querySelectorAll('select').length)) {
            document.querySelector('[data-getlook-all]').innerHTML = 'SOLD OUT';
            document.querySelector('[data-getlook-all]').setAttribute('disabled', true);
          } else {
            var calculateTotal = Shopify.formatMoney(totalAllPrice, window.globalVariables.money_format);
            document.querySelector('[data-getlook-all]').innerHTML = `<span class="add-text d-flex justify-content-center"><span class="text-for-print">ADD ALL PRODUCTS TO BAG - ${calculateTotal}</span></span><span class="spinner"></span>`
            document.querySelector('[data-getlook-all]').removeAttribute('disabled');
          }

          
          
        });
        
      }
      
    } catch (error) {
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while custom variants change.`)
    }
  }

  _getCollectionProductsData() {
    if(this.collection_products_json.textContent || this.collection_products_json.textContent != ''){
      this.collectionProductsData = JSON.parse(this.collection_products_json.textContent);
      return this.collectionProductsData;
    }else{
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while collection not found in product.`)
    }
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends HTMLElement {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.productNameMain = this.form.getAttribute('data-productTitle');
    this.formType = this.form.dataset.format;
    this.form = this.closest('form') || this.closest('.productForm');
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantjson]');

    this.variantPicker = this.dataset.type;
    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (this.variant_json) {
      this.Json_attribut = this.variant_json.getAttribute("thumbs-imgs");
    }

    if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));

    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }

  onVariantChange(event) {
    
    try{
      if(this.variantData || this.variant_json)
        this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      this.setCurrentVariant();
      // console.log('heyyy',this.currentVariant);
      let getawardEle = document.querySelector(`[data-award-match="${this.currentVariant.title}"]`);
      if (typeof(getawardEle) != 'undefined' && getawardEle != null){
        getawardEle.classList.remove('d-none');
      }
      if (this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

      this.form.querySelector('[name="id"]').value = this.currentVariant.id;

      if (this.Json_attribut) {
        this.manageSwatchImage(this.currentVariant);
      }
      this.getProductFromRadio(this.currentVariant);
      if (!this.currentVariant) {

        // Variant name update
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
          let lableID = 'option' + option.dataset.optionindex;
          const selectedValue = option.querySelector('input[type="radio"]:checked');
          const lable = option.querySelector('.selected-option');
          if (!lable || !lableID || !selectedValue) return;
          lable.innerHTML = selectedValue.value;
        });
      } else {
        if (this.formType == 'grid') {
          const productGrid = this.closest('[data-product-grid]');
        } else {
          if (event) {
            if (event == 'load') {
              //templateProductJS.prototype.manageVariantSlider(this.currentVariant);
            } else if (event) {

              if (this.form.querySelector('[data-checkvariantpreorder]').getAttribute('data-checkvariantpreorder') == "true") {
                // window.location.reload()
                let dataPreorderEnable = event.target.getAttribute('data-preorder-enable');
                let splashEndDateTime = event.target.getAttribute('data-splash-end-date-time');
                let preorderEndDateTime = event.target.getAttribute('data-preorder-end-date-time');
                let dataPreorderBtnText = event.target.getAttribute('data-preorder-btn-text');
                let dataPreorderdataDisclaimer = event.target.getAttribute('data-preorder-disclaimer');
                let dataPreorderTag = event.target.getAttribute('data-preorder-tag');
                let dataCurrentVariPrice = event.target.getAttribute('data-vari-price');
                let dataCurrentVariAvl = event.target.getAttribute('data-vari-available');
                let difference = -1;
                let preorderEndDateTimeMS = null;
                if (preorderEndDateTime) {
                  preorderEndDateTimeMS = new Date(preorderEndDateTime).getTime();
                  let currentDate = Date.now();
                  difference = preorderEndDateTimeMS - currentDate;
                }
                if (dataPreorderEnable == 'true' && difference < 0) {
                  dataPreorderEnable = 'false';
                }
                let preOrderCountdown = document.querySelector('[data-preorder-countdown]');
                preOrderCountdown.setAttribute('data-section_timer', splashEndDateTime);
                document.querySelectorAll('[data-btnaddtocart][data-main-product-btn]').forEach(ele => {
                  if (ele) {
                    ele.setAttribute('data-main-product-btn', dataPreorderEnable);
                  }
                });
                document.querySelectorAll('[name="properties[pre_order_date]"]').forEach(ele => {
                  if (ele) {
                    ele.value = preorderEndDateTimeMS;
                  }
                });
                document.querySelectorAll('[name="properties[pre_order]"]').forEach(ele => {
                  if (ele) {
                    ele.value = dataPreorderTag;
                  }
                });
                preOrderCountdown.manageCountdown(splashEndDateTime, dataPreorderBtnText, preorderEndDateTime, dataCurrentVariAvl, dataCurrentVariPrice, dataPreorderEnable);
                if (document.querySelector('[data-disclaimer]')) {
                  document.querySelectorAll('[data-disclaimer]').forEach(ele => {
                    if (ele) {
                      if (!dataPreorderEnable || dataPreorderEnable == 'false' || difference < 0) {
                        ele.classList.add('d-none');
                      } else {
                        ele.innerHTML = dataPreorderdataDisclaimer;
                        ele.classList.remove('d-none');
                      }
                    }
                  })
                }
              }

              let currentTarget = event.target;
              let pdpContainer = currentTarget.closest('[data-product-container]');
              let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
              let targetName = currentTarget.getAttribute('name') || '';
              targetName = targetName.toLowerCase();

              if (pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)) {
                if (quickShopModal) {
                  quickShop.prototype.manageVariantSlider(this.currentVariant);
                } else {
                  //templateProductJS.prototype.manageVariantSlider(this.currentVariant);
                }
              }
            }
          }

          const productPage = this.closest('[data-product-container]');
        }
      }
    }catch(error){
      console.log(error)
      //Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while custom variants change for onVariantChange function. ${error}`)
    }
  }
  setCurrentVariant() {
    try{
      // get all current values from selectors
      this.currentVariant = false;
      let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

      let variantsArray = this._getVariantData();
      variantsArray.find((variant) => {
        // get true or false based on options value presented in variant
        // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
        let mappedValues = variant.options.map((option, index) => {
          return options[index] === option;
        });

        // assign variant details to this.currentVariant if all options are present
        if (!mappedValues.includes(false)) {
          this.currentVariant = variant;
          return;
        }
      });
    }catch(error){
      if(this.productNameMain != 'Extend Shipping Protection Plan'){
        Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while set current variant: ${error}.`)
      }
    }
  }
  _getOptionsFromSelect() {
    try{
      let options = [];
      this.querySelectorAll('.variant_selector').forEach((selector) => {
        options.push(selector.value);
      });
      return options;
    }catch(error){
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while getting options from select.`)
    }
  }
  _getOptionsFromRadio() {
    try{
      const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
      const options = fieldsets.map((fieldset) => {
        if(Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked)){
          return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
        }
      });
      return options;
    }catch(error){
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while getting options from radio buttons: ${error}`)
    }
  }
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
  manageSwatchImage(currentVariant, currentTarget) {
    try{
      if(this.querySelector(`input[value="${currentVariant.title}"]`)) this.querySelector(`input[value="${currentVariant.title}"]`).dispatchEvent(new Event('click'));
      this.Shade_name = currentVariant.title;
      let setShadeDesc = '';
      let setShadeTitle = '';
      this.querySelectorAll('input[type="radio"]').forEach(ele => {
        if (ele.checked) {
          this.shadetitle = ele.dataset.shadevalue;
          this.shadeDesc = ele.dataset.shadedesc;
          this.ProductTitle = ele.dataset.title;
          let InnerText = ''
          let ShadeTitle = '';
          if (this.shadetitle != null || this.shadetitle != '') {
            InnerText = `${this.shadetitle}`;
            if (this.shadeDesc != '') {
              InnerText = `${this.shadetitle} - ${this.shadeDesc}`;
            }
            ShadeTitle = `${this.ProductTitle} - ${this.shadetitle}`
          } else {
            InnerText = `${this.shadeDesc}`;
          }
          
          setShadeDesc = document.querySelector('[data-setShadeDesc]');
          if (setShadeDesc) setShadeDesc.innerText = InnerText;
          setShadeTitle = document.querySelector('[data-setProductTitle]');
          if (ShadeTitle) { setShadeTitle.innerText = ShadeTitle }
        }
      });


      if(this.closest('.prouduct-slider-text')){
      
      this.ShadeImagesParent = this.closest('.prouduct-slider-text').querySelector('.product-thumbnails');
     
      this.ShadeImages = this.ShadeImagesParent.querySelectorAll('.swiper-slide');
      this.ShadeImages.forEach(ele => {
        
        if(ele.querySelector('img')){
        //let flag = ele.querySelector('img').alt;
        //if (flag == this.Shade_name ){
          
        let flag = ele.querySelector('img').alt.split(',');
        if (flag.includes(this.Shade_name)) {
          ele.style.display = "block";
        }
        else if (flag == "all") {
          ele.style.display = "block";
        }
        else {
          ele.style.display = "none";
        }
      }
      }
      )
   
    }
      setTimeout(function () {
        console.log('check for slider');
        window.dispatchEvent(new Event('resize'));
      }, 700)

    }catch(error){
      console.log(error)
      Rollbar.error(`Product name: ${this.productNameMain} Filename: Component-product-form.js, Error occured while getting options from radio buttons.(manageSwatchImage): ${error}`)
    }
  }
  getProductFromRadio(currentVariant) {
    
      let addToCartBtn = document.querySelector('[data-btnAddToCart]');
      let productAvail = currentVariant.available;
      let productPrice = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
      let productComparePrice = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);

      if (productAvail == false) {
        addToCartBtn.setAttribute('disabled', true);
        if (addToCartBtn.querySelector('.add-text .text-for-print')) {
          addToCartBtn.querySelector('.add-text .text-for-print').textContent = window.variantStrings.soldOut;
        }

      } else {
        addToCartBtn.removeAttribute('disabled');
        if (addToCartBtn.querySelector('.add-text .text-for-print')) {
          if (productComparePrice < productPrice) {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${productPrice}</span>`;
          } else {
            addToCartBtn.querySelector('.add-text .text-for-print').innerHTML = `ADD TO BAG - <span class="actual-price money" data-currentprice="">${productPrice}</span><span class="mb-0 h6 ms-1 money  text-decoration-line-through comparePrice" data-compareprice="">${productComparePrice}</span>`;
          }
        }

      };
    
  }

}
customElements.define('variant-radios', VariantRadios);


